export const NORMALIZE_CSS =
    '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/normalize/8.0.1/normalize.min.css" />';

// FUN-3908: Placeholder height for standalone AI embeds while the sandbox is
// still loading. AI blocks typically hold the main page content, so reserving
// most of the viewport keeps blocks below the embed (e.g. a CTA button) from
// flashing near the top of the page and jumping down once the real height
// arrives. Only applied when the embed is not inside a layout column.
export const AI_EMBED_LOADING_MIN_HEIGHT = '900px'; // iPhone viewport height is 874px

// CVT-4096: How long the reported height has to stay unchanged before it counts
// as the embed's final height. The sandbox reports every intermediate height
// while async content lands (a Tailwind CDN build, webfonts, images), so
// releasing the placeholder on the first report would reintroduce the jump
// FUN-3908 fixed. Long enough to bridge those, short enough to be unnoticeable.
export const EMBED_HEIGHT_SETTLE_DEBOUNCE_MS = 250;

// CVT-4096: Hard cap on the loading placeholder. A sandbox that never loads, or
// an embed that animates its height indefinitely, must not reserve the viewport
// forever.
export const EMBED_HEIGHT_SETTLE_TIMEOUT_MS = 5000;
